import { Row, Col, Card, Pagination, Result } from "antd";
import { useSelector } from "react-redux";
import { EditOutlined } from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import LoadingLibraryContent from "./LoadingLibraryContent";
import LazyImg from "./LazyImage";

const { Meta } = Card;

const Content = ({
  content,
  setSelectedItem,
  isLoading,
  currentPage,
  isFetching,
}: any) => {
  const { user, isAdmin } = useSelector((state: any) => state.auth);
  const history = useHistory();

  return (
    <div style={{ background: "transparent" }}>
      <Row gutter={15}>
        {isLoading || isFetching ? (
          // @ts-ignore
          <LoadingLibraryContent />
        ) : content && content.data.length === 0 ? (
          <div className="d-flex justify-content-center align-items-center h-100 w-100">
            <Result
              status="404"
              title="No fabric was found"
              subTitle="There is no fabric that muches your search."
            />
          </div>
        ) : (
          content.data.map((item: any) => (
            <Col
              className="gutter-row"
              key={item.id}
              xs={12}
              sm={8}
              lg={6}
              xl={4}
              style={{ marginTop: 15 }}
            >
              <Card
                style={{ cursor: "pointer" }}
                bodyStyle={{ padding: "15px 0" }}
                className="library-card"
                bordered={false}
                cover={
                  item.images.length !== 0 ? (
                    item.images.map((el: any) => (
                      <LazyImg
                        alt={el.fabric_id}
                        src={
                          el.image
                            ? process.env.REACT_APP_STORAGE_URL + el.image
                            : null
                        }
                        thumb={
                          el.image
                            ? process.env.REACT_APP_STORAGE_URL + el.image
                            : null
                        }
                        style={{
                          objectFit: "cover",
                          borderRadius: 0,
                          height: 263 / item.images.length,
                        }}
                      />
                    ))
                  ) : (
                    <LazyImg
                      alt={item.name}
                      src={
                        item.image
                          ? process.env.REACT_APP_STORAGE_URL + item.image
                          : null
                      }
                      thumb={
                        item.image
                          ? process.env.REACT_APP_STORAGE_URL + item.image
                          : null
                      }
                      style={{ objectFit: "cover", height: "263px" }}
                    />
                  )
                }
                actions={
                  user &&
                  isAdmin &&
                  // user.type !== "commercial" &&
                  user.permissions.includes("fabric-library.update") && [
                    <EditOutlined
                      key="edit"
                      width="100%"
                      height="100%"
                      onClick={() => setSelectedItem(item)}
                    />,
                  ]
                }
              >
                <Meta
                  title={
                    <Link
                      to={`/library/${item.id}`}
                      className="fabric-name-link"
                    >
                      {item.name}
                    </Link>
                  }
                />
              </Card>
            </Col>
          ))
        )}
      </Row>
      {content && (
        <Pagination
          className="library-pagination pt-3 d-flex justify-content-end"
          defaultCurrent={+currentPage || 1}
          defaultPageSize={12}
          total={content && content.total}
          hideOnSinglePage
          responsive
          onChange={(page: any) => history.push(`/library?page=${page}`)}
        />
      )}
    </div>
  );
};

export default Content;
